// extracted by mini-css-extract-plugin
export default {"layout":"DashboardLayout_layout__B39R+","mainContent":"DashboardLayout_mainContent__RYbt0","content":"DashboardLayout_content__zmsq9","overlay":"DashboardLayout_overlay__3LsPp"};